import {
  GraphQLOutputType,
  GraphQLNonNull,
  GraphQLList,
  isListType,
  GraphQLNamedType,
  GraphQLObjectType,
  GraphQLInterfaceType,
  isObjectType,
  isInterfaceType,
} from 'graphql'

/**
 * リスト型の判定
 * GraphQLNonNullでラップされている場合はネストされた型もチェックする
 */
export const isDeepListType = (type: GraphQLOutputType): type is GraphQLList<GraphQLOutputType> => {
  if (isListType(type)) {
    return true
  } else if (type instanceof GraphQLNonNull) {
    // GraphQLNonNullでラップされている場合はofTypeをたどって再帰的にチェック
    return isDeepListType(type.ofType)
  }

  return false
}

/**
 * オブジェクト型またはインターフェース型であるかの判定
 */
export const isGraphQLObjectOrInterfaceType = (
  type: GraphQLNamedType | undefined,
): type is GraphQLObjectType | GraphQLInterfaceType => isObjectType(type) || isInterfaceType(type)
